import * as types from "@/store/mutations";

const state = {
  expressUrl: "https://solid-cod-r4v46rxw545c5776-8000.app.github.dev",
  socketUrl: "https://retail-right-socket.herokuapp.com",
  pyUrl: "https://retail-right-flask.herokuapp.com",
};

export const getters = {
  expressUrl: (serviceState) => serviceState.expressUrl,
  socketUrl: (serviceState) => serviceState.socketUrl,
  pyUrl: (serviceState) => serviceState.pyUrl,
};

export const actions = {
  updateExpressUrl: ({ commit }, newUrl) => {
    commit(types.UPDATE_EXPRESS_URL, newUrl);
  },

  updateSocketUrl: ({ commit }, newUrl) => {
    commit(types.UPDATE_SOCKET_URL, newUrl);
  },

  updatePyUrl: ({ commit }, newUrl) => {
    commit(types.UPDATE_PY_URL, newUrl);
  },
};

export const mutations = {
  [types.UPDATE_EXPRESS_URL](serviceState, newUrl) {
    serviceState.expressUrl = newUrl;
  },
  [types.UPDATE_SOCKET_URL](serviceState, newUrl) {
    serviceState.socketUrl = newUrl;
  },
  [types.UPDATE_PY_URL](serviceState, newUrl) {
    serviceState.pyUrl = newUrl;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
